import { useEffect, useState } from "react";
import { useConfigLayout } from "../../../../hooks/useConfigLayout";
import UtilityPageLayout from "../../component/layout/UtilityPageLayout";
import styles from "./ActivityLogPage.module.scss";
import { BuildingGreenIcon, SearchBlueIcon, WarningIcon } from "../../../../assets/icons";
import StaticCard from "./components/static-card/StaticCard";
import Tabs, { TabItem } from "../../../../common/components/xepp/tab/Tabs";
import LogSearchTable from "./log-search/LogSearchTable";
import ReportedTable from "./reported/ReportedTable";
import { StaticCardDataParams, useGetStaticCardDataQuery } from "../../../../service/customersupport-service";

const ActivityLogPage = () => {
	const { updateLayout } = useConfigLayout();
	const [activeTab, setActiveTab] = useState("log-search");
	const [reportedFilter, setReportedFilter] = useState<StaticCardDataParams>({});

	useEffect(() => {
		updateLayout({
			showCountrySelector: false,
			utility: null,
			showExportButton: false,
			showBreadCrumb: false,
		});
	}, [updateLayout]);

	const { data, isLoading, isFetching } = useGetStaticCardDataQuery(reportedFilter);

	const tabs: TabItem[] = [
		{
			key: "log-search",
			label: "Log Search",
			content: (
				<>
					<LogSearchTable />
				</>
			),
		},
		{
			key: "reported",
			label: "Reported",
			content: (
				<>
					<ReportedTable onFilterChange={setReportedFilter} />
				</>
			),
		},
	];
	return (
		<>
			<UtilityPageLayout title="Activity Log">
				<div className={styles.staticCardsContainer}>
					<StaticCard label="Total Search" count={data?.totalSearch ?? 0} percentage={0} icon={SearchBlueIcon} />
					<StaticCard label="Staff Visit" count={data?.staffVisit ?? 0} percentage={0} icon={BuildingGreenIcon} />
					<StaticCard label="Reported Staffs" count={data?.reportedStaffs ?? 0} percentage={0} icon={WarningIcon} />
				</div>
				<Tabs tabs={tabs} activeTab={activeTab} onTabChange={key => setActiveTab(key)} />
			</UtilityPageLayout>
		</>
	);
};

export default ActivityLogPage;
